<template>
    <div class="garantie-view">
        <div class="garantie-view__head">
            <div class="garantie-view__head--icon" @click="$router.push('/devis')" v-if="showRetourButton">
                <font-awesome-icon prefix="fas" icon="arrow-circle-left"/>
                Retour
            </div>
        </div>
        <div class="garantie-view__head">
            <div class="garantie-view__head--title">
                Devis en ligne
            </div>
        </div>
        <div class="garantie-view__body">
            <div class="garantie-view__body__block">
                <div class="garantie-view__body__block--title">
                    Informations sur le propriétaire du Camping-Car :
                </div>
                <div class="garantie-view__body__block--content" v-if="!isBusy && guaranty && guaranty.client">
                    <div class="title">Vos coordonnées :</div>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Civilité :</div>
                                <div class="field__value">{{showGender}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Nom :</div>
                                <div class="field__value">{{guaranty.client.last_name || ''}}</div>
                            </div>
                        </div>
                        <template v-if="+guaranty.client.civility !== CLIENT_CIVILITY.SOCIETE.ID">
                            <div class="col-12 col-md-6" v-if="guaranty.client.first_name">
                                <div class="field">
                                    <div class="field__label">Prénom :</div>
                                    <div class="field__value">{{guaranty.client.first_name || ''}}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-12 col-md-6" v-if="guaranty.client.name_of_signatory">
                                <div class="field">
                                    <div class="field__label">Nom du signataire :</div>
                                    <div class="field__value">{{guaranty.client.name_of_signatory}}</div>
                                </div>
                            </div>
                        </template>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Adresse :</div>
                                <div class="field__value">{{guaranty.client.address || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Code postal :</div>
                                <div class="field__value">{{guaranty.client.zip || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Ville :</div>
                                <div class="field__value">{{guaranty.client.city || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Téléphone :</div>
                                <div class="field__value">{{guaranty.client.tel || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Fax :</div>
                                <div class="field__value">{{guaranty.client.fax || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Email :</div>
                                <div class="field__value">{{guaranty.client.email || ''}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <Preloader v-if="isBusy"/>
                <div class="garantie-view__body__block--title">
                    Informations sur le Camping-car à assurer :
                </div>
                <div class="garantie-view__body__block--content" v-if="!isBusy && guaranty.details">
                    <div class="title">Votre Camping-car :</div>
                    <div class="row">
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Camping car neuf :</div>
                                <div class="field__value">{{isNewCar(guaranty.details)}}</div>
                            </div>
                        </div>
                        <template v-if="isNewCar(guaranty.details) === isNon">
                          <div class="col-12" v-if="guaranty.details.cardans">
                              <div class="field">
                                  <div class="field__label field__label--bold col-8">Option A : Cardans, mécanisme d’embrayage, maître-cylindre et assistance de freinage
                                  </div>
                                  <div class="field__value">{{guaranty.details.cardans || ''}}</div>
                              </div>
                          </div>
                          <div class="col-12" v-if="guaranty.details.pumps">
                              <div class="field">
                                  <div class="field__label field__label--bold col-8">Option B : Pompe à eau, radiateur, moto ventilateur, alternateur, démarreur
                                  </div>
                                  <div class="field__value">{{guaranty.details.pumps || ''}}</div>
                              </div>
                          </div>
                          <div class="col-12" v-if="guaranty.details.injections">
                            <div class="field">
                                <div class="field__label field__label--bold col-8">Option C : Turbo, pompe à injection</div>
                                <div class="field__value">{{guaranty.details.injections || ''}}</div>
                            </div>
                        </div>
                        </template>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Durée :</div>
                                <div class="field__value">{{showDuration}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Immatriculation :</div>
                                <div class="field__value">{{guaranty.details.registration || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Marque du porteur :</div>
                                <div class="field__value">{{guaranty.details.marque_porteur || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Modèle du porteur :</div>
                                <div class="field__value">{{guaranty.details.modele_porteur || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Marque cellule :</div>
                                <div class="field__value">{{guaranty.details.marque_cellule || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Modèle cellule :</div>
                                <div class="field__value">{{guaranty.details.modele_cellule || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Date de 1ère mise en circulation :</div>
                                <div class="field__value">{{parseCirculationDate(guaranty.details) || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Numéro de série :</div>
                                <div class="field__value">{{guaranty.details.serial_number || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Puissance fiscale :</div>
                                <div class="field__value">{{guaranty.details.fiscal_power || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Date d'effet :</div>
                                <div class="field__value">{{parseEffectiveDate(guaranty.details)}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                          <div class="field">
                            <div class="field__label field__label--bold">Date de livraison :</div>
                            <div class="field__value">{{parseShippingDate(guaranty.details)}}</div>
                          </div>
                        </div>
                        <template v-if="isNewCar(guaranty.details) === isNon">
                            <div class="col-12">
                              <div class="field">
                                <div class="field__label field__label--bold">Prix de vente :</div>
                                <div class="field__value">{{showPxVente}}</div>
                              </div>
                            </div>
                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label field__label--bold">Kilométrage actuel :</div>
                                    <div class="field__value">{{getKmReal(guaranty.details)}}</div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label field__label--bold">Kilométrage limité à :</div>
                                    <div class="field__value">{{getKmLimit(guaranty.details)}}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label field__label--bold">Kilométrage limité à : 60 000 km</div>
                                    <div class="field__value"></div>
                                </div>
                            </div>
                        </template>
                        <div class="col-12" v-if="guaranty.finance == 1">
                          <div class="field">
                            <div class="field__label field__label--bold">Organisme de financement :</div>
                            <div class="field__value">{{guaranty.finance_name}}</div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="garantie-view__body__block--warning" v-if="numberOfDuplicates>0">
                    Attention ! Un contrat a déjà été saisi avec ce nom et ce numéro d’immatriculation.
                </div>
                <div class="garantie-view__body__block--link">
                    <router-link :to="/garantie-camping-car-dealer/ + $route.params.id">Cliquer ici pour modifier vos
                        coordonnées
                    </router-link>
                </div>
                <Preloader v-if="isBusy"/>
            </div>
            <div class="garantie-view__body__block mt-3">
                <div class="garantie-view__body__block--title">
                    VOUS AVEZ CHOISI LA GARANTIE POUR UNE DURÉE DE {{showDuration}}
                </div>

                <div class="garantie-view__body__block--content">
                    <div class="description">
                        <div class="label mb-2">
                            <div class="label--bold rem-18">Dur&eacute;e et prise d'effet</div>
                        </div>

                        <div class="font-weight-bold rem-14">
                            Sous r&eacute;serve du paiement de la prime et de l'acceptation de la garantie par
                            <strong>Dynassurances</strong>,
                            la garantie s'applique suivant la dur&eacute;e pr&eacute;cis&eacute;e aux conditions
                            particuli&egrave;res du contrat et prendra fin automatiquement &agrave; 24 heures jour pour
                            jour selon les dates indiqu&eacute;es sur le certificat de garantie.
                            <br/>
                            Cependant la garantie prendra fin de plein droit avant son terme :
                        </div>

                        <div class="list mt-3 rem-14">
                            <ul class="list__ul font-weight-bold">
                                <li>en cas de d&eacute;ch&eacute;ance du b&eacute;n&eacute;ficiaire de la garantie pour
                                    non respect des prescriptions du constructeur sur l'usage pour lequel le v&eacute;hicule
                                    est con&ccedil;u.
                                </li>
                            </ul>
                        </div>
                        <br class="mt-5">
                        <div class="price-block-new">
                            <div class="row">
                                <div class="col">
                                    «Carnet de prestation de services:
                                </div>
                              <template v-if="getPrice(guaranty)">
                                <div class="col text-right" style="padding-right: 80px;">
                                  <span>{{getPrice(guaranty)}} TTC (T.V.A. 20%)</span>»
                                </div>
                              </template>
                              <template v-else>
                                <div class="col text-left" style="padding-left: 80px;">
                                  <div class="label">
                                    <div class="label--red" v-if="mechanicCode != '705223'">
                                      Les critères du véhicule ne permettent pas de souscrire à la garantie choisie.<br />
                                      Pour effectuer une demande de dérogation, veuillez adresser le contrôle technique à l’adresse <a href="mailto:servicetechnique@dynassurances.fr">servicetechnique@dynassurances.fr</a> avec les informations suivantes :
                                      <ul>
                                        <li>Immatriculation du véhicule</li>
                                        <li>Votre code garage</li>
                                      </ul>
                                    </div>
                                    <div class="label--red" v-else>
                                      Les critères du véhicule ne permettent pas de souscrire à la garantie choisie.<br />
                                      Pour effectuer une demande de dérogation, veuillez adresser le contrôle technique avec les informations suivantes :
                                      <ul>
                                        <li>Immatriculation du véhicule</li>
                                        <li>Votre code garage</li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </div>
                            <template v-if="isPackAssistance(guaranty.details)">
                              <div class="row">
                                  <div class="col">
                                      «Abonnement Masters Pack Assistance pour une durée de 12 mois renouvelable (voir conditions): {{showAssistancePrice(guaranty)}}»
                                  </div>
                              </div>
                            </template>
                        </div>
                        <div class="insurance-info">
                            <div class="insurance-info__buttons">
                                <div
                                    class="insurance-info__buttons__item insurance-info__buttons__item--50 text-sm-right">
                                    <div class="insurance-info__buttons--wrapper">
                                        <a href="#" @click.prenevt="printInsurance()" class="blue">Imprimer le détail de
                                            la garantie</a>
                                        <div class="ball-anchor blue"></div>
                                    </div>
                                </div>
                                <div
                                    class="insurance-info__buttons__item insurance-info__buttons__item--50 text-sm-left">
                                    <div class="insurance-info__buttons--wrapper">
                                        <a href="#" @click.prenevt="getFrontPdf()" class="green">Sauvegarder sur mon
                                            ordinateur</a>
                                        <div class="ball-anchor green"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="print-page-break"></div>

                <div class="garantie-view__body__block mt-3">
                    <div class="garantie-view__body__block--title">
                        Garanties accordées
                    </div>
                    <div class="garantie-view__body__block--content">
                      <div class="description">
                        <div class="list mt-3">
                          <GrantedGuaranteesList :guaranty="guaranty"/>
                        </div>
                      </div>
                    </div>

                    <!--for reseau type-->
                    <template v-if="guaranty.details && guaranty.details.garantie == 1">
                        <div class="garantie-view__body__block--content">
                            <div class="description">
                                <div class="list mt-3">
                                    <ul class="list__ul">
                                        <li>
                                            <b>Moteur :</b>
                                            <div>
                                                L'arbre à cames, les coussinets de tête de bielle, les bielles, les
                                                culbuteurs et tiges de culbuteurs, poussoirs, chaînes de distribution,
                                                courroie de distribution (uniquement en cas de rupture), paliers de
                                                vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides,
                                                pompe à huile, culasse, joint de culasse et turbo.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Boîte de vitesse :</b>
                                            <div>
                                                <b>Manuelle</b> : Toutes les défaillances internes : Pignon, arbres,
                                                sélecteurs, synchros, roulements.
                                                <br>
                                                <b>Automatique</b> : Pignons, pompe à huile, bagues et arbres,
                                                convertisseur
                                                de couple, vannes et soupapes, régulateur, plateau.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Dans le dispositif de transmission :</b>
                                            <div>
                                                Boîte de transfert, pont arrière, différentiels, pignons et couronnes. A
                                                l'exception des arbres de roues, de transmission et des cardans.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Sont de plus garantis dans la cellule :</b>
                                            <div>
                                                Pompe à eau, chauffe-eau, agrégat réfrigérateur, transformateur et
                                                chargeur
                                                électrique, pulseur d'air.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Important :</b>
                                            <div>
                                                Cette garantie est réservée aux camping-cars de moins de 5 tonnes et
                                                moins
                                                de 120 000 Km à la souscription.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!--for maxi reseau type-->
                    <template v-else-if="guaranty.details && guaranty.details.garantie == 2">
                        <div class="garantie-view__body__block--content">
                            <div class="description">
                                <div class="list mt-3">
                                    <ul class="list__ul">
                                        <li>
                                            <b>Moteur :</b>
                                            <div>
                                                L'arbre à cames, les coussinets de tête de bielle, les bielles, les
                                                culbuteurs et tiges de culbuteurs, poussoirs, chaînes de distribution,
                                                courroie de distribution (uniquement en cas de rupture), paliers de
                                                vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides,
                                                pompe à huile, culasse, joint de culasse et turbo.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Boîte de vitesse :</b>
                                            <div>
                                                <b>Manuelle</b> : Toutes les défaillances internes : Pignon, arbres,
                                                sélecteurs, synchros, roulements.
                                                <br>
                                                <b>Automatique</b> : Pignons, pompe à huile, bagues et arbres,
                                                convertisseur de couple, vannes et soupapes, régulateur, plateau.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Dispositif de transmission :</b>
                                            <div>
                                                Boîte de transfert, pont arrière, différentiels, pignons et couronnes,
                                                cardans, arbre de transmission.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système de refroidissement :</b>
                                            <div>
                                                Radiateur d'eau, pompe à eau, ventilateur.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système électrique :</b>
                                            <div>
                                                Alternateur, démarreur, serrures de portes, moteur et mécanisme de
                                                lève-vitres, moteur d'essuie-glace et de toit ouvrant.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système de direction :</b>
                                            <div>
                                                Crémaillère ou boîtier, pompe d'assistance. A l'exception de la colonne,
                                                des rotules et des biellettes.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système de freinage :</b>
                                            <div>
                                                Maître-cylindre, servofrein, répartiteur, pompe à vide, bloc hydraulique
                                                ABS.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système d'alimentation :</b>
                                            <div>
                                                Allumeur, module électronique d'allumage, bobine, pompe à injection,
                                                boîtier électronique d'injection, pompes d'alimentation en carburant. A
                                                l'exception des injecteurs.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Dispositif d'embrayage :</b>
                                            <div>
                                                Mécanisme, fourchette, à l'exception du récepteur et émetteur
                                                d'embrayage.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Sont de plus garantis :</b>
                                            <div>
                                                Pompe à eau, chauffe-eau, agrégat réfrigèrateur, transformateur et
                                                chargeur électrique, pulseur d'air.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Important :</b>
                                            <div>
                                                Cette garantie est réservée aux camping-cars de moins de 5 tonnes et
                                                moins de 120 000 Km à la souscription.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="garantie-view__body__block--content">
                    <div class="description">

                        <div class="insurance-info">
                            <div class="insurance-info__buttons">
                                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                                    <div class="insurance-info__buttons--wrapper">
                                        <router-link :to="/garantie-camping-car-dealer/ + $route.params.id" class="blue">
                                            Modifier
                                        </router-link>
                                        <div class="ball-anchor blue"></div>
                                    </div>
                                </div>
                                <div class="insurance-info__buttons__item insurance-info__buttons__item--33" v-if="getPrice(guaranty)">
                                    <div class="insurance-info__buttons--wrapper">
                                        <a href="#" @click.prevent="checkSubscription(guaranty, getPDF)" class="purple">Souscrire
                                            à la
                                            garantie</a>
                                        <div class="ball-anchor purple"></div>
                                    </div>
                                </div>
                                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                                    <div class="insurance-info__buttons--wrapper">
                                        <router-link v-if="!showRetourButton" :to="'/'" class="black">Fermer
                                        </router-link>
                                        <router-link v-else :to="'/devis'" class="black">Fermer</router-link>
                                        <div class="ball-anchor black"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '@/components/Preloader'
    import insuranceMethods from "@/mixins/insuranceMethods";
    import GrantedGuaranteesList from "@/components/Garantie/DealerInsuranceCampingCar/DealerGuaranteesCampingCar";
    import {CLIENT_CIVILITY} from "@/constants/client";

    export default {
        name: 'DealerInsuranceCampingCarView',
        components: {
            Preloader,
          GrantedGuaranteesList
        },
        mixins: [insuranceMethods],
        data() {
            return {
                guaranty: {},
                isBusy: false,
                isBusyResend: false,
                gender_list: [
                    'M',
                    'Mlle',
                    'Mme',
                    'Société',
                ],
                family_status_list: [
                    'Célibataire',
                    'Marié(e)',
                ],
                professions_list: [
                    '',
                    'Artisant/commerçant',
                    'Exploitant agricole',
                    'Profession libérale',
                    'Chef d\'entreprise',
                    'Salarié',
                    'Fonctionnaire',
                    'VRP',
                    'Etudiant',
                    'Sans profession',
                    'Retraité'
                ],
                guaranty_list: [
                    '',
                    'Réseau',
                    'Maxi Réseau',
                    'Maxi Pluss'
                ],
                duration_list: [
                    '',
                    '6 Mois',
                    '12 Mois',
                    '24 Mois',
                    '36 Mois',
                    '48 Mois',
                    '18 Mois',
                ],
                assistance_list: [
                    'Pack Assistance',
                    'Sans pack assistance',
                ],
                pxVente_list: [
                  '',
                  'De 12 000 à 23 000 €',
                  'De 23 001 à 30 500 €',
                  'De 30 501 à 38 000 €',
                  'De 38 001 à 46 000 €',
                  'Plus de 45 000 €',
                ],
                showRetourButton: false,
                CLIENT_CIVILITY,
                pdfWindow: null,
                numberOfDuplicates: 0,
                isOui: "Oui",
                isNon: "Non"
            }
        },
        computed: {
            getDownloadLinkConfirmationPdf() {
                if (this.guaranty.id)
                    return this.getApiAuthUrl('garantie/confirmation-pdf/' + this.guaranty.id);

                return '';
            },
            showGender() {
                return this.gender_list[this.guaranty.client.civility] ? this.gender_list[this.guaranty.client.civility] : '';
            },
            showFamilyStatus() {
                return this.family_status_list[this.guaranty.client.family] ? this.family_status_list[this.guaranty.client.family] : '';
            },
            showProfession() {
                return this.professions_list[this.guaranty.client.profession] ? this.professions_list[this.guaranty.client.profession] : '';
            },
            // Details
            showGuaranty() {
                return this.guaranty_list[this.guaranty.details.garantie] ? this.guaranty_list[this.guaranty.details.garantie] : '';
            },
            showDuration() {
                if (this.guaranty && this.guaranty.details) {
                    return this.duration_list[this.guaranty.details.duration] ? this.duration_list[this.guaranty.details.duration] : '';
                }
            },
            showPxVente() {
              if (this.guaranty && this.guaranty.details) {
                return this.pxVente_list[this.guaranty.details.px_vente] ? this.pxVente_list[this.guaranty.details.px_vente] : '';
              }
            },
            getDownloadLink() {
                if (this.guaranty.id)
                    return this.getApiAuthUrl('garantie/generate-pdf/' + this.guaranty.id);

                return '';
            },
            getDownloadLinkCopyPdf() {
                if (this.guaranty.id)
                    return this.getApiAuthUrl('garantie/front-copy-pdf/' + this.guaranty.id);

                return '';
            }
        },
        methods: {
            parseCirculationDate(details) {
                let day = details.day_circulation,
                    month = details.month_circulation - 1,
                    year = details.year_circulation;

                day.length < 2 ? day = '0' + day.toString() : '';
                month.length < 2 ? month = '0' + month.toString() : '';

                let date = this.moment(new Date).date(day).month(month).year(year);
                return date.format('DD/MM/YYYY');
            },
            parseSaleDate(quoteDatails) {
                if (quoteDatails.sale_date) {
                    return this.moment(quoteDatails.sale_date).format('DD/MM/Y');
                }

                return '';
            },
            parseEffectiveDate(quoteDatails) {
                if (quoteDatails.effective_date) {
                    return this.moment(quoteDatails.effective_date).format('DD/MM/Y');
                }

                return '';
            },
            parseShippingDate(quoteDatails) {
                if (quoteDatails.shipping_date) {
                    return this.moment(quoteDatails.shipping_date).format('DD/MM/Y');
                }

                return '';
            },
            parseDeliveryDate(quoteDatails) {
                if (quoteDatails.delivery_date) {
                    return this.moment(quoteDatails.delivery_date).format('DD/MM/Y');
                }

                return '';
            },
            parseBirthDate(quoteDatails) {
                if (quoteDatails.client.birthday) {
                    let day = quoteDatails.client.datesParse.day_birth,
                        month = quoteDatails.client.datesParse.month_birth,
                        year = quoteDatails.client.datesParse.year_birth;
                    return this.moment(quoteDatails.client.birthday).format('DD/MM/Y');
                }

                return '';
            },
            getGuarantyInfo() {
                this.isBusy = true;
                let url = 'garantie/' + this.$route.params.id;
                this.apiGet(url).then(response => {
                    this.guaranty = response.data.quote ? response.data.quote : {};
                    this.numberOfDuplicates = response.data.duplicates;
                    this.isBusy = false;
                  // alert('apiget '+this.isBusy);
                  // alert(JSON.stringify(this.guaranty));
                  // alert(JSON.stringify(this.guaranty.client));
                }).catch(error => {
                    this.showErrorNotification(error);
                    this.$router.push('/');
                })
              // alert('ggi'+this.isBusy);
            },
            printInsurance() {
                window.print();
            },
            resendEmail() {
                this.isBusyResend = true;
                let url = 'garantie/resend-email/' + this.guaranty.id;

                this.apiPost(url, {}).then((response) => {
                    this.isBusyResend = false;
                    if (response.data.quote && response.data.status == 'success') {
                        this.showSuccessNotification(response.data.message, '');
                        this.$set(this.guaranty, 'was_sent', response.data.quote.was_sent);
                    }
                }).catch(error => {
                    this.isBusyResend = false;
                    this.showErrorNotification(error);
                })

            },
            getPDF() {
                if (this.checkEffectiveDate(this.guaranty)) {
                    this.refreshTokenForce().then((response) => {
                        if (this.getDownloadLink) {
                            let pdfWindow = window.open(this.getDownloadLink);
                            if (pdfWindow) this.pdfWindow = pdfWindow;
                        } else {
                            this.showWarningNotification('Quote Not Found');
                        }
                    }).catch(error => {
                        this.showErrorNotification(error);
                    });
                } else {
                    this.showWarningNotification('La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d\'effet de la garantie.');
                }
            },
            getConfirmationPDF() {
                this.refreshTokenForce().then((response) => {
                    if (this.getDownloadLinkConfirmationPdf) {
                        window.location = this.getDownloadLinkConfirmationPdf;
                    } else {
                        this.showWarningNotification('Quote Not Found');
                    }
                }).catch(error => {
                    console.log(error)
                    this.showErrorNotification(error);
                });
            },
            getFrontPdf() {
                this.refreshTokenForce().then((response) => {
                    if (this.getDownloadLinkCopyPdf) {
                        window.open(this.getDownloadLinkCopyPdf);
                    } else {
                        this.showWarningNotification('Quote Not Found');
                    }
                }).catch(error => {
                    this.showErrorNotification(error);
                });
            },
            isNewCar (quoteDatails) {
              if (quoteDatails.is_new === this.isOui) {
                return this.isOui;
              }
              return this.isNon;
            },
            getKmReal (quoteDatails) {
              if (quoteDatails.km_real !== null) {
                return `${quoteDatails.km_real} km`;
              }
              return quoteDatails.km_real || '';
            },
            getKmLimit (quoteDatails) {
                if (quoteDatails.km_day !== null) {
                  return `${quoteDatails.km_day} km`;
                }
                return quoteDatails.km_day || '';
              },
            showAssistanceMode (quoteDetails) {
              if (typeof quoteDetails !== 'undefined') {
                return (+quoteDetails.assistance === 1) ? this.isNon : this.isOui;
              }
              return this.isNon;
            },
            showAssistancePrice (quote) {
              if (typeof quote['assistance_price'] !== 'undefined') {
                return `${this.formatFloatNumberWithComma(`${quote['assistance_price']}`)} TTC (Taxe d’Assurance. 18%)`;
              }
            },
            getPrice(quote) {
                return quote.price ? this.roundEURWithoutSymbol(quote.price).replace('.', ',') + ' €' : '';
              },
            isNewCampingCar(quoteDetails) {
              if (typeof quoteDetails !== 'undefined') {
                return (quoteDetails.is_new === this.isOui);
              }
              return false;
            },
            isPackAssistance(quoteDetails) {
              if (typeof quoteDetails !== 'undefined') {
                return +quoteDetails.assistance === 0;
              }
              return false;
            }
        },
        mounted() {
            this.getGuarantyInfo();
            this.$eventBus.$emit('sidebar-set-active-tab', 'Garantie Camping Car');

            if (this.$store.state.backToDevisListActive) {
                this.showRetourButton = true;
                this.$store.dispatch('backToDevisDisable');
            }
        },
        beforeDestroy() {
            this.$eventBus.$emit('sidebar-set-active-tab', '');
        },
        watch: {
            pdfWindow: function () {
                window.location.href = '/merci';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/DealerInsuranceCampingCar/DealerInsuranceCampingCarView.vue